var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(CharactersEndpoint, _AbstractEndpoint);

  function CharactersEndpoint(client, name) {
    var _this;

    _classCallCheck(this, CharactersEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CharactersEndpoint).call(this, client));
    _this.name = name;
    _this.url = '/v2/characters';
    _this.isPaginated = true;
    _this.isBulk = true;
    _this.supportsBulkAll = false;
    _this.isAuthenticated = true;
    _this.cacheTime = 5 * 60;
    return _this;
  }

  _createClass(CharactersEndpoint, [{
    key: "backstory",
    value: function backstory() {
      return new BackstoryEndpoint(this, this.name);
    }
  }, {
    key: "core",
    value: function core() {
      return new CoreEndpoint(this, this.name);
    }
  }, {
    key: "crafting",
    value: function crafting() {
      return new CraftingEndpoint(this, this.name);
    }
  }, {
    key: "equipment",
    value: function equipment() {
      return new EquipmentEndpoint(this, this.name);
    }
  }, {
    key: "heropoints",
    value: function heropoints() {
      return new HeropointsEndpoint(this, this.name);
    }
  }, {
    key: "inventory",
    value: function inventory() {
      return new InventoryEndpoint(this, this.name);
    }
  }, {
    key: "recipes",
    value: function recipes() {
      return new RecipesEndpoint(this, this.name);
    }
  }, {
    key: "sab",
    value: function sab() {
      return new SabEndpoint(this, this.name);
    }
  }, {
    key: "skills",
    value: function skills() {
      return new SkillsEndpoint(this, this.name);
    }
  }, {
    key: "specializations",
    value: function specializations() {
      return new SpecializationsEndpoint(this, this.name);
    }
  }, {
    key: "training",
    value: function training() {
      return new TrainingEndpoint(this, this.name);
    }
  }]);

  return CharactersEndpoint;
}(AbstractEndpoint);

var BackstoryEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint2) {
  "use strict";

  _inherits(BackstoryEndpoint, _AbstractEndpoint2);

  function BackstoryEndpoint(client, character) {
    var _this2;

    _classCallCheck(this, BackstoryEndpoint);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BackstoryEndpoint).call(this, client));
    _this2.url = "/v2/characters/".concat(encodeURIComponent(character), "/backstory");
    _this2.isAuthenticated = true;
    _this2.cacheTime = 5 * 60;
    return _this2;
  }

  _createClass(BackstoryEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(BackstoryEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.backstory;
      });
    }
  }]);

  return BackstoryEndpoint;
}(AbstractEndpoint);

var CoreEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint3) {
  "use strict";

  _inherits(CoreEndpoint, _AbstractEndpoint3);

  function CoreEndpoint(client, character) {
    var _this3;

    _classCallCheck(this, CoreEndpoint);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(CoreEndpoint).call(this, client));
    _this3.url = "/v2/characters/".concat(encodeURIComponent(character), "/core");
    _this3.isAuthenticated = true;
    _this3.cacheTime = 5 * 60;
    return _this3;
  }

  return CoreEndpoint;
}(AbstractEndpoint);

var CraftingEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint4) {
  "use strict";

  _inherits(CraftingEndpoint, _AbstractEndpoint4);

  function CraftingEndpoint(client, character) {
    var _this4;

    _classCallCheck(this, CraftingEndpoint);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(CraftingEndpoint).call(this, client));
    _this4.url = "/v2/characters/".concat(encodeURIComponent(character), "/crafting");
    _this4.isAuthenticated = true;
    _this4.cacheTime = 5 * 60;
    return _this4;
  }

  _createClass(CraftingEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(CraftingEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.crafting;
      });
    }
  }]);

  return CraftingEndpoint;
}(AbstractEndpoint);

var EquipmentEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint5) {
  "use strict";

  _inherits(EquipmentEndpoint, _AbstractEndpoint5);

  function EquipmentEndpoint(client, character) {
    var _this5;

    _classCallCheck(this, EquipmentEndpoint);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(EquipmentEndpoint).call(this, client));
    _this5.url = "/v2/characters/".concat(encodeURIComponent(character), "/equipment");
    _this5.isAuthenticated = true;
    _this5.cacheTime = 5 * 60;
    return _this5;
  }

  _createClass(EquipmentEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(EquipmentEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.equipment;
      });
    }
  }]);

  return EquipmentEndpoint;
}(AbstractEndpoint);

var HeropointsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint6) {
  "use strict";

  _inherits(HeropointsEndpoint, _AbstractEndpoint6);

  function HeropointsEndpoint(client, character) {
    var _this6;

    _classCallCheck(this, HeropointsEndpoint);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(HeropointsEndpoint).call(this, client));
    _this6.url = "/v2/characters/".concat(encodeURIComponent(character), "/heropoints");
    _this6.isAuthenticated = true;
    _this6.cacheTime = 5 * 60;
    return _this6;
  }

  return HeropointsEndpoint;
}(AbstractEndpoint);

var InventoryEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint7) {
  "use strict";

  _inherits(InventoryEndpoint, _AbstractEndpoint7);

  function InventoryEndpoint(client, character) {
    var _this7;

    _classCallCheck(this, InventoryEndpoint);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(InventoryEndpoint).call(this, client));
    _this7.url = "/v2/characters/".concat(encodeURIComponent(character), "/inventory");
    _this7.isAuthenticated = true;
    _this7.cacheTime = 5 * 60;
    return _this7;
  }

  _createClass(InventoryEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(InventoryEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.bags;
      });
    }
  }]);

  return InventoryEndpoint;
}(AbstractEndpoint);

var RecipesEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint8) {
  "use strict";

  _inherits(RecipesEndpoint, _AbstractEndpoint8);

  function RecipesEndpoint(client, character) {
    var _this8;

    _classCallCheck(this, RecipesEndpoint);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(RecipesEndpoint).call(this, client));
    _this8.url = "/v2/characters/".concat(encodeURIComponent(character), "/recipes");
    _this8.isAuthenticated = true;
    _this8.cacheTime = 5 * 60;
    return _this8;
  }

  _createClass(RecipesEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(RecipesEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.recipes;
      });
    }
  }]);

  return RecipesEndpoint;
}(AbstractEndpoint);

var SabEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint9) {
  "use strict";

  _inherits(SabEndpoint, _AbstractEndpoint9);

  function SabEndpoint(client, character) {
    var _this9;

    _classCallCheck(this, SabEndpoint);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(SabEndpoint).call(this, client));
    _this9.url = "/v2/characters/".concat(encodeURIComponent(character), "/sab");
    _this9.isAuthenticated = true;
    _this9.cacheTime = 5 * 60;
    return _this9;
  }

  return SabEndpoint;
}(AbstractEndpoint);

var SkillsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint10) {
  "use strict";

  _inherits(SkillsEndpoint, _AbstractEndpoint10);

  function SkillsEndpoint(client, character) {
    var _this10;

    _classCallCheck(this, SkillsEndpoint);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(SkillsEndpoint).call(this, client));
    _this10.url = "/v2/characters/".concat(encodeURIComponent(character), "/skills");
    _this10.isAuthenticated = true;
    _this10.cacheTime = 5 * 60;
    return _this10;
  }

  _createClass(SkillsEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(SkillsEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.skills;
      });
    }
  }]);

  return SkillsEndpoint;
}(AbstractEndpoint);

var SpecializationsEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint11) {
  "use strict";

  _inherits(SpecializationsEndpoint, _AbstractEndpoint11);

  function SpecializationsEndpoint(client, character) {
    var _this11;

    _classCallCheck(this, SpecializationsEndpoint);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(SpecializationsEndpoint).call(this, client));
    _this11.url = "/v2/characters/".concat(encodeURIComponent(character), "/specializations");
    _this11.isAuthenticated = true;
    _this11.cacheTime = 5 * 60;
    return _this11;
  }

  _createClass(SpecializationsEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(SpecializationsEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.specializations;
      });
    }
  }]);

  return SpecializationsEndpoint;
}(AbstractEndpoint);

var TrainingEndpoint =
/*#__PURE__*/
function (_AbstractEndpoint12) {
  "use strict";

  _inherits(TrainingEndpoint, _AbstractEndpoint12);

  function TrainingEndpoint(client, character) {
    var _this12;

    _classCallCheck(this, TrainingEndpoint);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(TrainingEndpoint).call(this, client));
    _this12.url = "/v2/characters/".concat(encodeURIComponent(character), "/training");
    _this12.isAuthenticated = true;
    _this12.cacheTime = 5 * 60;
    return _this12;
  }

  _createClass(TrainingEndpoint, [{
    key: "get",
    value: function get() {
      return _get(_getPrototypeOf(TrainingEndpoint.prototype), "get", this).call(this).then(function (result) {
        return result.training;
      });
    }
  }]);

  return TrainingEndpoint;
}(AbstractEndpoint);